import { ActionsUnion, createAction } from 'vrlcm-gui-utils';
import {
  DirectoryConfigData,
  DomainSelectionData,
  MapAttributeData,
  PreviewData,
  TestConnectionData,
  VidmDetails,
  WizardData,
  WizardLevelState,
  WizardState
} from '../types/state/AddDirectory';
import { DirectoryType, GroupMappingItem } from 'vrlcm-gui-types';

import { StepState } from '@vmware-react/vrlcm';

export const INITIALIZE_AD_WIZARD_PAGE =
  'add-directory/INITIALIZE_AD_WIZARD_PAGE';
export const INITIALIZE_AD_WIZARD_PAGE_SUCCESS =
  'add-directory/INITIALIZE_AD_WIZARD_PAGE_SUCCESS';
export const INITIALIZE_AD_WIZARD_PAGE_FAIL =
  'add-directory/INITIALIZE_AD_WIZARD_PAGE_FAIL';

export const UPDATE_WIZARD_DATA = 'add-directory/UPDATE_WIZARD_DATA';

export const UPDATE_DIRECTORY_DATA = 'add-directory/UPDATE_DIRECTORY_DATA';
export const UPDATE_DOMAIN_SELECTION_DATA =
  'add-directory/UPDATE_DOMAIN_SELECTION_DATA';

export const UPDATE_MAP_ATTRIBUTE_DATA =
  'add-directory/UPDATE_MAP_ATTRIBUTE_DATA';

export const UPDATE_PREVIEW_STEP_DATA =
  'add-directory/UPDATE_PREVIEW_STEP_DATA';

export const UPDATE_TEST_CONNECTION_DATA =
  'add-directory/UPDATE_TEST_CONNECTION_DATA';
export const TRIGGER_TEST_CONNECTION = 'add-directory/TRIGGER_TEST_CONNECTION';

export const UPDATE_WIZARD_STEP_VALIDITY =
  'add-directory/UPDATE_WIZARD_STEP_VALIDITY';

export const UPDATE_WIZARD_CURRENT_STEP =
  'add-directory/UPDATE_WIZARD_CURRENT_STEP';

export const UPDATE_WIZARD_STEP_STATE =
  'add-directory/UPDATE_WIZARD_STEP_STATE';

export const DISABLE_AND_CLEAR_STEP_STATE_FROM_STEP =
  'add-directory/DISABLE_AND_CLEAR_STEP_STATE_FROM_STEP';

export const CREATE_DIRECTORY_AND_MOVE_TO_NEXT_STEP =
  'add-directory/CREATE_DIRECTORY_AND_MOVE_TO_NEXT_STEP';

export const PROCESS_CURRENT_STEP_AND_MOVE_TO_NEXT_STEP =
  'add-directory/PROCESS_CURRENT_STEP_AND_MOVE_TO_NEXT_STEP';
export const SAVE_STEP_AND_SYNC = 'add-directory/SAVE_STEP_AND_SYNC';
export const MOVE_TO_NEXT_STEP = 'add-directory/MOVE_TO_NEXT_STEP';

export const UPDATE_DIRECTORY_CONFIG_ID =
  'add-directory/UPDATE_DIRECTORY_CONFIG_ID';

export const GROUP_SELECTION_TRIGGER_GROUP_SYNC =
  'add-directory/GROUP_SELECTION_TRIGGER_GROUP_SYNC';

export const GROUP_SELECTION_TRIGGER_GROUP_SYNC_COMPLETED =
  'add-directory/GROUP_SELECTION_TRIGGER_GROUP_SYNC_COMPLETED';
export const GROUP_SELECTION_TRIGGER_GROUP_SYNC_FAILED =
  'add-directory/GROUP_SELECTION_TRIGGER_GROUP_SYNC_FAILED';

export const GROUP_SELECTION_ADD_NEW_GROUP =
  'add-directory/GROUP_SELECTION_ADD_NEW_GROUP';
export const GROUP_SELECTION_REMOVE_GROUP =
  'add-directory/GROUP_SELECTION_REMOVE_GROUP';
export const GROUP_SELECTION_CHANGE_GROUP_DN =
  'add-directory/GROUP_SELECTION_CHANGE_GROUP_DN';

export const GROUP_SELECTION_NAVIGATE_TO_SUB_GROUP_SELECTION =
  'add-directory/GROUP_SELECTION_NAVIGATE_TO_SUB_GROUP_SELECTION';
export const GROUP_SELECTION_NAVIGATE_TO_MAIN_PAGE =
  'add-directory/GROUP_SELECTION_NAVIGATE_TO_MAIN_PAGE';

export const GROUP_SELECTION_UPDATE_SUB_GROUP_SELECTION =
  'add-directory/GROUP_SELECTION_UPDATE_SUB_GROUP_SELECTION';
export const GROUP_SELECTION_SELECT_ALL_SUB_GROUPS =
  'add-directory/GROUP_SELECTION_SELECT_ALL_SUB_GROUPS';
export const GROUP_SELECTION_UNSELECT_ALL_SUB_GROUPS =
  'add-directory/GROUP_SELECTION_UNSELECT_ALL_SUB_GROUPS';

export const GROUP_SELECTION_UPDATE_SYNC_NESTED_GROUP_FLAG =
  'add-directory/GROUP_SELECTION_UPDATE_SYNC_NESTED_GROUP_FLAG';

export const USER_SELECTION_ADD_NEW_USER =
  'add-directory/USER_SELECTION_ADD_NEW_USER';
export const USER_SELECTION_REMOVE_USER =
  'add-directory/USER_SELECTION_REMOVE_USER';
export const USER_SELECTION_CHANGE_USER =
  'add-directory/USER_SELECTION_CHANGE_USER';

export const SUBMIT_WIZARD = 'add-directory/SUBMIT_WIZARD';

export const UPDATE_WIZARD_LEVEL_STATE =
  'add-directory/UPDATE_WIZARD_LEVEL_STATE';

export const Actions = {
  initializeADWizardPage: (opts: {
    add?: { directoryType: DirectoryType };
    update?: { directoryConfigId: string; directoryType: DirectoryType };
  }) => createAction(INITIALIZE_AD_WIZARD_PAGE, opts),
  initializeADWizardPageFail: () =>
    createAction(INITIALIZE_AD_WIZARD_PAGE_FAIL),
  initializeADWizardPageSuccess: (
    wizardState: WizardState,
    wizardData?: WizardData,
    vidmDetails?: VidmDetails
  ) =>
    createAction(INITIALIZE_AD_WIZARD_PAGE_SUCCESS, {
      wizardData,
      wizardState,
      vidmDetails
    }),
  updateStepValidity: (step: number, valid: boolean) =>
    createAction(UPDATE_WIZARD_STEP_VALIDITY, { step, valid }),
  updateWizardCurrentStep: (step: number) =>
    createAction(UPDATE_WIZARD_CURRENT_STEP, step),
  submitWizard: (editPage: boolean) => createAction(SUBMIT_WIZARD, editPage),
  updateWizardStepState: (
    step: number,
    newState: { valid?: boolean; disabled?: boolean; state?: StepState }
  ) => createAction(UPDATE_WIZARD_STEP_STATE, { step, state: newState }),
  disableAndClearStepStateFromStep: (from: number) =>
    createAction(DISABLE_AND_CLEAR_STEP_STATE_FROM_STEP, from),
  processCurrentStepAndMoveToNextStep: (step: number) =>
    createAction(PROCESS_CURRENT_STEP_AND_MOVE_TO_NEXT_STEP, step),
  saveStepAndSync: (step: number) => createAction(SAVE_STEP_AND_SYNC, step),
  moveToNextStep: (step: number) => createAction(MOVE_TO_NEXT_STEP, step),
  createDirectoryAndMoveToNextStep: () =>
    createAction(CREATE_DIRECTORY_AND_MOVE_TO_NEXT_STEP),
  updateWizardData: (wizardData: WizardData) =>
    createAction(UPDATE_WIZARD_DATA, wizardData),
  updateWizardLevelState: (wizardLevelState: Partial<WizardLevelState>) =>
    createAction(UPDATE_WIZARD_LEVEL_STATE, wizardLevelState),
  updateDirectoryConfigId: (directoryConfigId: string) =>
    createAction(UPDATE_DIRECTORY_CONFIG_ID, directoryConfigId),
  updateDirectoryData: (data: DirectoryConfigData) =>
    createAction(UPDATE_DIRECTORY_DATA, data),
  updateDomainSelectionData: (data: DomainSelectionData) =>
    createAction(UPDATE_DOMAIN_SELECTION_DATA, data),
  updateMapAttributeData: (mapAttributeData: MapAttributeData) =>
    createAction(UPDATE_MAP_ATTRIBUTE_DATA, mapAttributeData),
  updateTestConnectionData: (testConnectionData: TestConnectionData) =>
    createAction(UPDATE_TEST_CONNECTION_DATA, testConnectionData),
  triggerTestConnection: () => createAction(TRIGGER_TEST_CONNECTION),

  groupSelectionUpdateSyncNestedGroupFlag: (syncNestedGroup: boolean) =>
    createAction(
      GROUP_SELECTION_UPDATE_SYNC_NESTED_GROUP_FLAG,
      syncNestedGroup
    ),
  groupSelectionAddNewGroup: () => createAction(GROUP_SELECTION_ADD_NEW_GROUP),
  groupSelectionRemoveGroup: (index: number) =>
    createAction(GROUP_SELECTION_REMOVE_GROUP, index),
  groupSelectionChangeGroupDN: (index: number, groupDN: string) =>
    createAction(GROUP_SELECTION_CHANGE_GROUP_DN, { index, groupDN }),
  groupSelectionTriggerSync: (groupDN: string) =>
    createAction(GROUP_SELECTION_TRIGGER_GROUP_SYNC, groupDN),
  groupSelectionGroupSyncCompleted: (
    groupDN: string,
    subGroups: GroupMappingItem[],
    syncedOn: Date,
    moreThan1000Groups: boolean
  ) =>
    createAction(GROUP_SELECTION_TRIGGER_GROUP_SYNC_COMPLETED, {
      groupDN,
      subGroups,
      syncedOn,
      moreThan1000Groups
    }),
  groupSelectionGroupSyncFailed: (groupDN: string, errors?: string[]) =>
    createAction(GROUP_SELECTION_TRIGGER_GROUP_SYNC_FAILED, {
      groupDN,
      errors
    }),
  groupSelectionNavigateToSubGroupSelection: (index: number) =>
    createAction(GROUP_SELECTION_NAVIGATE_TO_SUB_GROUP_SELECTION, index),
  groupSelectionNavigateToMainPage: () =>
    createAction(GROUP_SELECTION_NAVIGATE_TO_MAIN_PAGE),
  groupSelectionUpdateSubGroupSelection: (
    parentGroupDN: string,
    selectedGroups: GroupMappingItem[]
  ) =>
    createAction(GROUP_SELECTION_UPDATE_SUB_GROUP_SELECTION, {
      parentGroupDN,
      selectedGroups
    }),
  groupSelectionSelectAllSubGroups: (parentGroupDN: string) =>
    createAction(GROUP_SELECTION_SELECT_ALL_SUB_GROUPS, parentGroupDN),
  groupSelectionUnSelectAllSubGroups: (parentGroupDN: string) =>
    createAction(GROUP_SELECTION_UNSELECT_ALL_SUB_GROUPS, parentGroupDN),
  userSelectionAddNewUser: () => createAction(USER_SELECTION_ADD_NEW_USER),
  userSelectionRemoveUser: (index: number) =>
    createAction(USER_SELECTION_REMOVE_USER, index),
  userSelectionChangeUser: (index: number, userDN: string) =>
    createAction(USER_SELECTION_CHANGE_USER, { index, userDN }),
  updatePreviewStepData: (previewData: PreviewData) =>
    createAction(UPDATE_PREVIEW_STEP_DATA, previewData)
};

export type Actions = ActionsUnion<typeof Actions>;
